import type * as Sentry from '@sentry/react';

export type ErrorFilter = (event: Sentry.ErrorEvent) => boolean;

export interface ErrorFilterConfig {
  name: string;
  enabled: boolean;
  filter: ErrorFilter;
}

function shouldDropEvent(
  errorFilters: ErrorFilterConfig[],
  event: Sentry.ErrorEvent,
): boolean {
  for (const filterConfig of errorFilters) {
    if (!filterConfig.enabled) {
      continue;
    }

    try {
      if (filterConfig.filter(event)) {
        return true;
      }
    } catch {
      // Swallow errors in filters to prevent breaking Sentry
      return false;
    }
  }

  return false;
}

export const filterEvent = (
  errorFilters: ErrorFilterConfig[],
  event: Sentry.ErrorEvent,
) => {
  return shouldDropEvent(errorFilters, event) ? null : event;
};
